import * as angular from 'angular';
import {IController} from "angular";
import {OrderPlanningConfigurationService} from "../../services/order-planning-configuration.service";
import * as _ from "lodash";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {OrderPlanningAlertsService} from "../../services/order-planning-alerts.service";

export class CustomOrderPlanningConfigurationComponent implements IController {


  onClose: Function;

  configuration: any;
  minimumDeliveryDate: any;

  constructor(private orderPlanningConfigurationService: OrderPlanningConfigurationService, private confirmDialogService: ConfirmDialogService,
              private orderPlanningAlertsService: OrderPlanningAlertsService, private moment) {
  }


  onSelectConfiguration(configuration) {
    this.configuration = configuration;
  }

  onCreateNewConfiguration() {
    this.configuration = {};

    this.configuration.defaultQuantityPackages = 1;
    this.configuration.defaultQuantityWeight = 1;
    this.configuration.defaultStopTripNumber = 1;
    this.configuration.handleMissingStopSequence = true;
    // this.configuration.defaultDeliveryDate = 'TOMORROW';
  }

  // onChangeDeliveryDefaultDate(defaultDeliveryDate) {
  //   this.configuration.defaultDeliveryDate = defaultDeliveryDate;
  // }

  onTemplateSelect(template) {
    this.configuration.projectTemplateId = template.id;
  }

  onSelectDepot(id) {
    this.configuration.defaultPickupDepotId = id;
  }

  onVehicleSelect(vehicle) {
    this.configuration.defaultVehicleId = vehicle.id;
  }

  onSelectZone(zoneId) {
    this.configuration.zoneIdName = zoneId;
  }

  onSelectProgram(programType) {
    this.configuration.programType = programType;
  }

  onDelete() {
    this.confirmDialogService.confirm('Delete Configuration', 'Are you sure you want to delete this configuration?', event)
      .then(() => {
        this.orderPlanningConfigurationService.delete(this.configuration.id)
          .then(() => {
            this.orderPlanningAlertsService.deleteConfigurationSuccess();
            this.onClose();
          })
          .catch(err => {
            this.orderPlanningAlertsService.deleteConfigurationError();
          })
      })
  }

  onSubmit(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.saveConfiguration()
      }
    }
  }

  private saveConfiguration() {
    if (this.configuration.id) {
      this.orderPlanningConfigurationService.update(this.configuration)
        .then(() => {
          this.orderPlanningAlertsService.updateConfigurationSuccess();

          this.onClose();
        })
        .catch((err) => {
          this.orderPlanningAlertsService.updateConfigurationError();
        })
    } else {
      this.orderPlanningConfigurationService.create(this.configuration)
        .then(() => {
          this.orderPlanningAlertsService.createConfigurationSuccess();
          this.onClose();
        })
        .catch((err) => {
          this.orderPlanningAlertsService.createConfigurationError();
        })
    }
  }

}

angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningConfiguration', {
    bindings: {
      onClose: '&'
    },
    template: require('./custom-order-planning-configuration.html').default,
    controller: CustomOrderPlanningConfigurationComponent
  });
